// extracted by mini-css-extract-plugin
export default {"wrap":"FormTransactionRow_wrap__e1kdx"};